import { render } from "./LoginForm.vue?vue&type=template&id=042d4bf5"
import script from "./LoginForm.vue?vue&type=script&lang=ts"
export * from "./LoginForm.vue?vue&type=script&lang=ts"
script.render = render

export default script